import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getGST, saveGST } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';


class gst extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              gsts: [],
              cgst: '',
              sgst: '',
        };

        this.getGST();
    }


    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_school', function () {
        var delete_id = $(this).data("id");
        THIS.setState({
          delete_id: delete_id
        })
      });


    }


  handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
  }


    getGST = () => {
      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role
      });
      getGST(ins).then((res) => {
        if (res.status == 1) {
          this.setState({
            gst: res.data.gst,
            cgst: res.data.cgst,
            sgst:res.data.sgst
            
          });
        } 
      });
    }    


  submitForm = (e) => {

      let req = JSON.stringify({
        gst: this.state.gst,
        cgst: this.state.cgst,
        sgst: this.state.sgst,
        id: 1
      });

      console.log(req);

      saveGST(req).then(res => {
        let toastr = '';
        if (res.status === 1) {
           alert("dfdf");
            
        } else {
           alert("error");
        }
      });
   
  }

    render() {

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">GST (taxes) </h4>

                  <div  class="row">
                  <div class="col-lg-12">
                  
                        <div className="box-shadow-custom">
                          <div className="row">
                            <div className="form-group col-md-4">
                              <label className="text-capitalize">BeWise's GST number<span className="astrick">*</span></label>
                              <input type='text' className='form-control' onChange={this.handleChange} name='gst' value={this.state.gst} />
                               
                            </div>
                          </div>
                          
                          <div className="row">
                            <div className="form-group col-md-4">
                              <label className="text-capitalize">CGST(%)<span className="astrick">*</span></label>
                              <input type='text' className='form-control' onChange={this.handleChange} name='cgst' value={this.state.cgst} />
                               
                            </div>
                          </div>

                          <div className="row">
                            <div className="form-group col-md-4">
                              <label className="text-capitalize">SGST(%)<span className="astrick">*</span></label>
                              <input type='text' className='form-control' onChange={this.handleChange} name='sgst' value={this.state.sgst} />
                               
                            </div>
                          </div>


                        </div>

                        <div className="col-md-12 col-xs-12 btn-bdr">
                          <button id="btnSubmit" className="btn btn-primary btn-sm" onClick={this.submitForm}>Submit</button>
                        </div>
                      
                       </div>
                  </div>

              

                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default gst;


// WEBPACK FOOTER //
// ./src/components/bewise/adminGst.jsx